import { SmartMTEditorPopup, updateSaveButtons } from "./_editor_popup";
import { getBlobUrl, getImgBlob, setImgBlob, setCurrentMode, showToastMessage } from "./_utils";

var $ = jQuery;

export const Convert = (attachment) => {
    $('#smart-mt-convert').on('click', function () {
        setCurrentMode('convert');
        let imgBlob = getImgBlob();
        let url = getBlobUrl(imgBlob) !== false ? getBlobUrl(imgBlob) : attachment.url;

        const currentFormat = attachment.mime;

        let convertContent = `
            <div class="smart-mt-content smart-mt-content-convert">
                <img id="smartmt-edit-image" src="${url}" alt="${attachment.name}" />
            </div>`;

        let formatOptions = `
            ${currentFormat !== "image/jpeg" ? '<option value="image/jpeg">JPG</option>' : ""}
            ${currentFormat !== "image/png" ? '<option value="image/png">PNG</option>' : ""}
            ${currentFormat !== "image/webp" ? '<option value="image/webp">WEBP</option>' : ""}
        `;

        let convertSidebar = `
            <div id="convert-controls" class="sidebareffects">
                <div>
                    <strong>Converting from:</strong> <span>${currentFormat}</span>
                </div>
                <div>
                    <label for="format-select">Convert To</label>
                    <select id="format-select">${formatOptions}</select>
                    ${currentFormat === "image/png" || currentFormat === "image/svg+xml" ? `
                    <div id="background-color-picker">
                        <label for="background-color">Select Background Color</label>
                        <input type="color" id="background-color" value="#ffffff" />
                    </div>` : ""}
                </div>
            </div>
            <div class="button-access">
                <button class="button" id="convert-apply">
                    <span class="dashicons dashicons-saved"></span> Apply
                </button>
                <button class="button" id="convert-reset">
                    <span class="dashicons dashicons-no-alt"></span> Reset
                </button>
            </div>`;

        SmartMTEditorPopup(convertContent, convertSidebar);

        bindConvertControls();

        function bindConvertControls() {
            const backgroundColorPicker = document.getElementById('background-color');
            const imageElement = document.getElementById('smartmt-edit-image');

            const originalSrc = imageElement.src;
            const originalBackgroundColor = imageElement.style.backgroundColor;

            if (backgroundColorPicker) {
                backgroundColorPicker.addEventListener('input', function () {
                    imageElement.style.backgroundColor = backgroundColorPicker.value;
                });
            }

            document.getElementById('convert-reset').addEventListener('click', function () {
                imageElement.src = originalSrc;
                imageElement.style.backgroundColor = originalBackgroundColor;

                if (backgroundColorPicker) {
                    backgroundColorPicker.value = '#ffffff';
                }

                showToastMessage("Image and background reset to default.", "success");
            });

            $(document).on('click', '#convert-apply', function () {
                const format = $('#format-select').val();
                const backgroundColor = backgroundColorPicker ? backgroundColorPicker.value : null;
                applyConversion(format, backgroundColor);
            });
        }

        function applyConversion(format, backgroundColor) {
            const imageElement = document.getElementById("smartmt-edit-image");
            if (!imageElement) {
                showToastMessage("Image element not found.", "error");
                return;
            }

            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            canvas.width = imageElement.naturalWidth;
            canvas.height = imageElement.naturalHeight;

            if ((format === 'image/jpeg' || format === 'image/webp') && backgroundColor) {
                ctx.fillStyle = backgroundColor;
                ctx.fillRect(0, 0, canvas.width, canvas.height);
            }

            ctx.drawImage(imageElement, 0, 0, canvas.width, canvas.height);

            canvas.toBlob((blob) => {
                if (blob) {
                    const convertedImageURL = URL.createObjectURL(blob);

                    setImgBlob(blob);
                    $('#smartmt-edit-image').attr('src', convertedImageURL);

                    showToastMessage(`Successfully converted to ${format.split('/')[1].toUpperCase()}.`, "success");
                } else {
                    showToastMessage("Failed to convert image. Please try again.", "error");
                }
            }, format);
        }
    });
};
